'use strict';

export default () => {
    const module = {};

    const easingFnc = o_util.animation.easings.easeOutCubic;
    const animationDuration = 500;
    const animationStartedTime = animationDuration / 4;

    module.registerAnimationStartedCallback = (startedOrStoppedAnimationCallback) => {
        setTimeout(startedOrStoppedAnimationCallback, animationStartedTime);
    };

    module.scrollAnimation = (from, to, scrollPosFn, startedOrStoppedAnimationCallback) => {
        module.registerAnimationStartedCallback(startedOrStoppedAnimationCallback);
        scrollAnimation(from, to, scrollPosFn, startedOrStoppedAnimationCallback);
    };

    const scrollAnimation = (from, to, setScrollPositionFn, startedOrStoppedAnimationCallback, startTime = 0) => {

        const now = new Date().getTime();
        /*🤫*/
        startTime = startTime === 0 ? now : startTime;

        const currentState = (now - startTime) / animationDuration;

        /*🤫*/
        if (currentState > 1) {
            setScrollPositionFn(to);
            startedOrStoppedAnimationCallback();
            return;
        }

        /*🤫*/
        const newScrollPosition = getNewScrollPosition(from, to, currentState, easingFnc);
        setScrollPositionFn(newScrollPosition);

        /*🤫*/
        o_util.animation.requestAnimFrame(() => {
            scrollAnimation(from, to, setScrollPositionFn, startedOrStoppedAnimationCallback, startTime);
        });
    };

    const getNewScrollPosition = (from, to, currentState, easingFnc) => {
        return from - ((from - to) * easingFnc(currentState));
    };

    return module;
};